import { supabase } from "../../config/supabase";

interface Product {
  id: string;
  product_name: string;
  nitrogen_n: number;
  phosphorus_p2o5: number;
  potassium_k2o: number;
  calcium_cao: number;
  magnesium_mgo: number;
  sulfur_so3: number;
}

interface ProductData {
  product: string;
  countN: number;
  countP2O5: number;
  countK2O: number;
  countCaO: number;
  countMgO: number;
  countSO3: number;
}

class ProductService {
  async listProducts() {
    try {
      const { data, error } = await supabase
        .from("products")
        .select("*")
        .order("product_name", { ascending: true });

      if (error) {
        console.error("Error fetching products:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in listProducts:", error);
      return { success: false, error };
    }
  }

  async createProduct(productData: ProductData) {
    try {
      const { data, error } = await supabase
        .from("products")
        .insert({
          ...productData,
          user_id: (await supabase.auth.getUser()).data.user?.id,
        })
        .select()
        .single();

      if (error) {
        console.error("Error creating product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in createProduct:", error);
      return { success: false, error };
    }
  }

  async updateProduct(productId: string, productData: ProductData) {
    try {
      const { data, error } = await supabase
        .from("products")
        .update(productData)
        .eq("id", productId)
        .select()
        .single();

      if (error) {
        console.error("Error updating product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in updateProduct:", error);
      return { success: false, error };
    }
  }

  async deleteProduct(productId: string) {
    try {
      const { error } = await supabase
        .from("products")
        .delete()
        .eq("id", productId);

      if (error) {
        console.error("Error deleting product:", error);
        return { success: false, error };
      }

      return { success: true };
    } catch (error) {
      console.error("Error in deleteProduct:", error);
      return { success: false, error };
    }
  }

  async getProductById(productId: string) {
    try {
      const { data, error } = await supabase
        .from("products")
        .select("*")
        .eq("id", productId)
        .single();

      if (error) {
        console.error("Error fetching product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in getProductById:", error);
      return { success: false, error };
    }
  }

  async existsProductByName(product_name: string) {
    try {
      const { data, error } = await supabase
        .from("products")
        .select("id")
        .ilike("product_name", product_name);
      if (error) {
        console.error("Error checking product by name:", error);
        return { success: false, error };
      }
      return { success: true, exists: Array.isArray(data) && data.length > 0 };
    } catch (error) {
      console.error("Error in existsProductByName:", error);
      return { success: false, error };
    }
  }
}

// Create and export a singleton instance
export const productService = new ProductService();
